import { __extends } from "tslib";
import { noop } from 'lodash-es';
import PropTypes from 'prop-types';
import { Component } from 'react';
var EmbedlySizer = /** @class */ (function (_super) {
    __extends(EmbedlySizer, _super);
    function EmbedlySizer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setContainerHeight = function () {
            var _a = _this.props, naturalDeviceWidth = _a.naturalDeviceWidth, naturalDeviceHeight = _a.naturalDeviceHeight;
            var containerWidth = window.innerWidth;
            if (containerWidth > naturalDeviceWidth) {
                _this.props.setContainerHeight(naturalDeviceHeight);
            }
            else {
                var scale = containerWidth / naturalDeviceWidth;
                var height = scale * naturalDeviceHeight;
                _this.props.setContainerHeight(height);
            }
        };
        return _this;
    }
    EmbedlySizer.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.setContainerHeight);
        this.setContainerHeight();
    };
    EmbedlySizer.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.setContainerHeight);
    };
    EmbedlySizer.prototype.render = function () {
        return null;
    };
    EmbedlySizer.propTypes = {
        naturalDeviceWidth: PropTypes.number.isRequired,
        naturalDeviceHeight: PropTypes.number.isRequired,
        setContainerHeight: PropTypes.func.isRequired,
    };
    EmbedlySizer.defaultProps = {
        setContainerHeight: noop,
    };
    return EmbedlySizer;
}(Component));
export default EmbedlySizer;
